import React from 'react';
import { BookOpen, Bot, Calendar, Palette, Globe, Layout, Video } from 'lucide-react';

const services = [
  {
    icon: Video,
    title: 'The Digital Ghostwriter',
    description: 'Transform voice notes into a month\'s worth of multi-platform content (LinkedIn, newsletters, X/Twitter). You talk, we type. Simple.',
    gradient: 'linear-gradient(135deg, #C41E3A 0%, #E74C3C 100%)',
    iconBg: 'rgba(255, 255, 255, 0.9)',
    tier: 'Fixed-Price',
    textColor: '#FFFFFF'
  },
  {
    icon: BookOpen,
    title: 'The Information Sieve',
    description: 'Weekly "Action Briefs" summarizing industry content you don\'t have time to read. We filter the noise, you get the gold.',
    gradient: 'linear-gradient(135deg, #43A047 0%, #66BB6A 100%)',
    iconBg: 'rgba(255, 255, 255, 0.9)',
    tier: 'Fixed-Price',
    textColor: '#FFFFFF'
  },
  {
    icon: Bot,
    title: 'The AI Operations Audit',
    description: 'We find the repetitive tasks eating your time and automate them. One setup, ongoing freedom.',
    gradient: 'linear-gradient(135deg, #C0C0C0 0%, #E8E8E8 100%)',
    iconBg: 'rgba(255, 255, 255, 0.9)',
    tier: 'One-Time Setup',
    textColor: '#1a1a1a'
  },
  {
    icon: Layout,
    title: 'Landing Pages & Websites',
    description: 'Professional websites that work while you sleep. With chatbots like Brendan to capture leads 24/7.',
    gradient: 'linear-gradient(135deg, #D4AF37 0%, #F4E4C1 100%)',
    iconBg: 'rgba(255, 255, 255, 0.9)',
    tier: 'Custom Build',
    textColor: '#1a1a1a'
  },
  {
    icon: Calendar,
    title: 'AI Strategy Chat',
    description: 'Not sure where to start? We\'ll have a cuppa and figure out what AI can actually do for your specific situation.',
    gradient: 'linear-gradient(135deg, #43A047 0%, #81C784 100%)',
    iconBg: 'rgba(255, 255, 255, 0.9)',
    tier: 'Free Consultation',
    textColor: '#FFFFFF'
  },
  {
    icon: Palette,
    title: 'Creative & Design',
    description: 'Videos, images, posters, merchandise — from your rough idea to polished result. No design skills needed on your end.',
    gradient: 'linear-gradient(135deg, #43A047 0%, #C41E3A 50%, #D4AF37 100%)',
    iconBg: 'rgba(255, 255, 255, 0.9)',
    tier: 'Fixed-Price',
    textColor: '#FFFFFF'
  }
];

const ServicesSection = () => {
  return (
    <section className="py-20 px-4" style={{ background: '#1a1a1a' }}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4" style={{ color: '#FFFFFF' }}>Our Service Menu</h2>
          <p className="body-large" style={{ color: '#C0C0C0', maxWidth: '800px', margin: '0 auto 1rem' }}>
            No job is too big, too small, or too silly. You drop off the problem, we hand back the result.
          </p>
          <p className="body-medium" style={{ color: '#D4AF37', maxWidth: '700px', margin: '0 auto', fontWeight: '600' }}>
            Fixed prices • No jargon • 50/50 payment for peace of mind
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="voice-card hover-lift"
                style={{
                  background: service.gradient,
                  padding: '2rem',
                  borderRadius: '1rem',
                  border: '1px solid var(--glass-border)',
                  transition: 'all 0.3s ease',
                  cursor: 'default'
                }}
              >
                <div 
                  className="mb-4"
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '50%',
                    background: service.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid rgba(0, 0, 0, 0.1)'
                  }}
                >
                  <Icon size={28} color="#000000" />
                </div>
                <h3 className="heading-3 mb-3" style={{ color: service.textColor, fontWeight: '700' }}>{service.title}</h3>
                <p className="caption mb-2" style={{ color: service.textColor === '#FFFFFF' ? '#FFD700' : 'var(--gold-primary)', fontWeight: '700', textTransform: 'uppercase' }}>
                  {service.tier}
                </p>
                <p className="body-medium" style={{ color: service.textColor, fontWeight: '500', opacity: service.textColor === '#FFFFFF' ? 1 : 0.85, lineHeight: '1.6' }}>
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;